var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatSocialMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medium"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1531 10.1178C10.1531 12.9459 7.88021 15.2384 5.07663 15.2384C2.27305 15.2384 0 12.9454 0 10.1178C0 7.29033 2.27287 4.99707 5.07663 4.99707C7.88038 4.99707 10.1531 7.28981 10.1531 10.1178Z",
    fill: "#DD5800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.7221 10.1177C15.7221 12.7797 14.5856 14.9385 13.1838 14.9385C11.7819 14.9385 10.6454 12.7797 10.6454 10.1177C10.6454 7.4557 11.7817 5.29688 13.1836 5.29688C14.5855 5.29688 15.7219 7.45501 15.7219 10.1177",
    fill: "#DD5800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18 10.118C18 12.5025 17.6004 14.4367 17.1073 14.4367C16.6142 14.4367 16.2147 12.503 16.2147 10.118C16.2147 7.733 16.6143 5.79932 17.1073 5.79932C17.6002 5.79932 18 7.73283 18 10.118Z",
    fill: "#DD5800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatSocialMedium);
export default __webpack_public_path__ + "static/media/sat_social_medium.ac3ee3859daf9c111c679bbf01be3b3d.svg";
export { ForwardRef as ReactComponent };